import { agentPerformanceData } from "@/mocks/reportsData";

export default function AgentPerformanceTable({ onExport }: { onExport?: () => void }) {
  const getConvColor = (rate: number) => {
    if (rate >= 12) return "text-green-600";
    if (rate >= 8) return "text-amber-600";
    return "text-red-600";
  };

  const getInitials = (name: string) =>
    name.split(" ").map((n) => n[0]).join("").toUpperCase();

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-5 py-4 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900">Agent Performance</h3>
          {onExport && (
            <button
              onClick={onExport}
              className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors cursor-pointer"
              title="Export CSV"
            >
              <i className="ri-download-line text-sm" />
            </button>
          )}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 bg-gray-50">
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Agent</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Assigned</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Contacted</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Converted</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Revenue</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">Conv%</th>
            </tr>
          </thead>
          <tbody>
            {agentPerformanceData.map((agent) => (
              <tr key={agent.agent} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2.5">
                    <div className="w-7 h-7 rounded-full bg-indigo-100 flex items-center justify-center text-[10px] font-bold text-indigo-700 flex-shrink-0">
                      {getInitials(agent.agent)}
                    </div>
                    <span className="font-medium text-gray-900">{agent.agent}</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-gray-700">{agent.assigned}</td>
                <td className="px-4 py-3 text-gray-700">{agent.contacted}</td>
                <td className="px-4 py-3 text-gray-700 font-medium">{agent.converted}</td>
                <td className="px-4 py-3 text-gray-900 font-semibold">{agent.revenue}</td>
                <td className="px-4 py-3 text-right">
                  <span className={`text-sm font-bold ${getConvColor(agent.convRate)}`}>
                    {agent.convRate}%
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}